package de.oevbs.kunde.kundenportal2.services.deregistercar

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.model.services.deregistercar.DeregisterCar
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.Handler
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class DeregisterCarStore(job: Job) : ValidatingStore<DeregisterCar, Unit, ComponentValidationMessage>(
    initialData = DeregisterCar(),
    validation = DeregisterCar.validation,
    metadataDefault = Unit,
    job = job,
    validateAfterUpdate = false
) {
    private val client = DeregisterCarClient()

    val unsubscribeCarProgressStore = storeOf(GeneralProgressStep.SUBMIT1, job)

    val carContractsStore = storeOf(emptyList<CarContract>(), job)
    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data
    val initContractsModel: Handler<Unit> = carContractsStore.handle {
        GlobalServiceMessagesStore.clear(Unit)
        globalInitTracker.track {
            resetMessages()
            val initData = initPartnerData()
            if (initData == null) {
                initFailedStore.update(true)
                return@track emptyList()
            }
            initData
        }
    }

    val submitUnsubscribeRequest: Handler<Unit> = handle { currentModel ->
        GlobalServiceMessagesStore.clear(Unit)

        if (!validate(currentModel).valid)
            return@handle currentModel

        globalSubmitTracker.track {
            if (submitDeregistration(currentModel)) {
                unsubscribeCarProgressStore.update(GeneralProgressStep.SUCCESS2)
            }
            currentModel
        }
    }

    private suspend fun initPartnerData(): List<CarContract>? {
        return tryCatchAndHandleErrors("Initialisieren der Kfz-Verträge") {
            client.init()
        }
    }

    private suspend fun submitDeregistration(deregisterCar: DeregisterCar): Boolean {
        tryCatchAndHandleErrors("Abmelden eines Fahrzeugs") {
            client.deregister(deregisterCar)
        } ?: return false

        return true
    }

    private fun testData() = listOf(
        CarContract("24389", "PKW", "BS AU 345"),
        CarContract("2222289", "Anhänger", "OHA DA 1234"),
        CarContract("11345235", "Lastkraftwagen", "B EN 1")
    )
}